const defaultState = {
    finalList: [],
    loading: false,
    errors:{},
    soundsOn: true
}
  
  export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_TO_DO_LIST_FULFILLED': {
        return {
          ...state,
          finalList: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_TO_DO_LIST_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_TO_DO_LIST_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }

      case 'FETCH_TO_DO_HC_LIST_FULFILLED': {
        return {
          ...state,
          finalList: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_TO_DO_HC_LIST_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_TO_DO_HC_LIST_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }

      case 'SOUNDS_ON_STATE_CHANGE': {
        return {
          ...state,
          soundsOn: !state.soundsOn
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/to-do-reducer.js